import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/otac/appointment-request/:base64Data?",
    component: () => import("@/otac/views/AppointmentRequest.vue"),
    meta: { title: "Appointment Request" }
  },
  {
    path: "/otac/document-upload/:token?",
    component: () => import("@/otac/views/DocumentUpload.vue"),
    meta: { title: "Document Upload" }
  },
  {
    path: "/:catchAll(.*)",
    component: () => import("@/otac/views/NotFound404.vue"),
    meta: { title: "404: Not Found" }
  }
];

const routerOTAC = createRouter({ 
  history: createWebHistory(import.meta.env.BASE_URL), 
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.path !== from.path) return { top: 0 };
  }
});

// set page titles on each route change
routerOTAC.beforeEach((to, from, next) => {
  document.title = (to.meta?.title ? (to.meta.title + " | ") : "") + "WarehouseQuote";
  next();
});

export default routerOTAC;